/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Meta_TitleInputs */

const en_pc_alt_meta_title = /** @type {(inputs: Pc_Alt_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft Alternatives (2026): An Honest PDF Editor Comparison`)
};

const zh_pc_alt_meta_title = /** @type {(inputs: Pc_Alt_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 替代方案（2026）：PDF 编辑器客观对比`)
};

/**
* | output |
* | --- |
* | "PdfCraft Alternatives (2026): An Honest PDF Editor Comparison" |
*
* @param {Pc_Alt_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_meta_title = /** @type {((inputs?: Pc_Alt_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_meta_title(inputs)
	return zh_pc_alt_meta_title(inputs)
});
export { pc_alt_meta_title as "pc.alt.meta_title" }